<template>
  <div class="com-wrap">
    <div @click="showDialog">
      <slot></slot>
    </div>
    <el-dialog title="选择套餐" :visible.sync="dialogVisible" destroy-on-close>
      <div class="search-wrap mwow-form">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="请输入套餐名称"
          v-model="searchName"
          @change="handleSearch"
          maxlength="30"
          clearable
        ></el-input>
      </div>
      <div class="table-wrap">
        <el-table size="mini" :data="tableData" v-horizontal-scroll stripe>
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                @change="handleSetSelect(scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="套餐名称"></el-table-column>
          <el-table-column prop="price" label="套餐价">
            <template slot-scope="scope">￥{{ scope.row.price }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="bottom-wrap">
        <p class="text">已选择：{{ selectedList.length }}项</p>
        <div class="btns">
          <div class="mwow-button-filled" @click="hideDialog">取消</div>
          <div class="mwow-button-filled success" @click="formSubmit">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { setList } from "@/api/course";

export default {
  props: {
    originData: {
      type: Array,
    },
    max: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      dialogVisible: false,
      searchName: "",
      tableData: [],
      selectedList: [],
      selectedObject: {},
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      row: {},
    };
  },
  watch: {
    selectedList: {
      handler(n) {
        if (n.length > this.max) {
          delete this.selectedObject[this.row.combo_product_id];
          this.selectedList = this.selectedList.slice(0, this.max);
          this.$message({
            message: `最多只能选${this.max}个套餐`,
            type: "warning",
          });
          return;
        }
      },
      deep: true,
    },
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    showDialog() {
      this.dialogVisible = true;
      this.selectedList = this.originData;
      let obj = {};
      this.originData.map((item) => {
        obj[item.combo_product_id] = item;
      });
      this.selectedObject = obj;
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    hideDialog() {
      this.dialogVisible = false;
      this.selectedObject = {};
      this.selectedList = [];
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        status: 1,
      };
      if (this.searchName) {
        option.name = this.searchName;
      }
      setList(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            if (this.selectedObject[item.combo_product_id]) {
              item.checked = true;
            } else {
              item.checked = false;
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        }
      });
    },
    handleSetSelect(row) {
      let copy = { ...this.selectedObject };
      this.row = row;
      if (copy[row.combo_product_id]) {
        delete copy[row.combo_product_id];
      } else {
        copy[row.combo_product_id] = row;
      }
      this.selectedObject = copy;

      let items = [];
      for (let key in copy) {
        items.unshift(copy[key]);
      }
      this.selectedList = items;
      let index = this.tableData.findIndex((item) => {
        return item.combo_product_id === row.combo_product_id;
      });
      if (this.selectedList.length > this.max) {
        this.tableData[index].checked = false;
        return;
      }
      if (index >= 0) {
        this.tableData[index].checked = !!copy[row.combo_product_id];
      }
    },
    formSubmit() {
      this.$emit("on-change", this.selectedList);
      this.hideDialog();
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-wrap {
  margin-bottom: 12px;
  text-align: left;
  .el-input {
    width: 220px;
  }
  .icon {
    font-size: 14px;
    margin-left: 12px;
  }
}
.pagination-wrap {
  overflow: hidden;
}
.bottom-wrap {
  border-top: 1px solid #e7e8ea;
  display: flex;
  padding: 20px 20px 0 20px;
  margin: 0 -20px;
  .text {
    flex: 1;
    line-height: 30px;
    text-align: left;
  }
  .btns {
    .mwow-button-filled {
      margin-left: 12px;
    }
  }
}
</style>
